import { ClearBracesPage } from "~/components/clear-braces/ClearBracesPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/clear-braces")({
  head: async () =>
    (await import("~/utils/liveSeoHead")).headFromLiveSeo("/clear-braces"),
  component: ClearBracesPage,
});
